// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__24-QL","inputDescription":"styles_inputDescription__2lq28"};